import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { endPoints } from "../api-end-points";
import { BlogapiService } from "./blogapi.service";

@Injectable({
  providedIn: 'root'
})

export class BlogService {
  constructor(
    private blogApiCall: BlogapiService,) { }


  getFirstThreeBlog(): Observable<any> {
    return this.blogApiCall.Get(endPoints.GET_TOP_THREE);
  }
  getBlogDetails(pageId: number): Observable<any> {
    return this.blogApiCall.GetBlogDetails(endPoints.GET_BLOG_DETAILS + pageId + '&_embed', { 'Content-Type': 'application/json; charset=utf-8' }, 'json');
  }
  getBlogData(numOfBlogs: number): Observable<any> {
    return this.blogApiCall.Get(endPoints.GET_BLOG, { 'per_page': numOfBlogs });
  }
  getBlogImages(url: string): Observable<any> {
    return this.blogApiCall.Get(url, null, null, null, false);
  }

}
